module.exports = __webpack_public_path__ + "static/img/9.38a6629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/9.jpg
// module id = DNTX
// module chunks = 1